import React from "react";
 

import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS ,LOCAL_PATHS} from "../../../Constants";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import {  Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight } from "react-icons/fa";
import * as XLSX from 'xlsx';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import CardBox from "../../../components/CardBox";

const PayrollSelection = (props) => {


  const history = useHistory();
  
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
 
  const [status, setstatus] = useState('10003')

  const [saveStatus, setSavestatus] = useState(10001)



  
  const [payroll_tracks, setpayroll_tracks] = useState([])
  const [selected_track_id, setSelected_track_id] = useState([]);
  
  const [isLoading, setIsLoading] = useState(false);

 
const [showModal, setshowModal] = useState(false)
const [showUndoModal, setShowUndoModal] = useState(false)
const [selected_payroll, setselected_payroll] = useState(null)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const toggle = () => setshowModal(!showModal);
 
  useEffect(() => {
    listTracks();
   
    return () => {};
  }, []);


  const listPayrollDetails = () => {
    setIsLoading(true);
    genericPost(ENDPOINTS.LIST_TRACK_PAYROLL_DETAILS, {
      "track_id": selected_track_id,
      "status":status
  })
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
        
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
        
            setRowData(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const listTracks = () => {
    setIsLoading(true);
    genericGet(ENDPOINTS.LIST_PAYROLL_TRACKS, {})
      .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
        
          if (res.data.status == SUCCESS_RESULT) {
            let responseData = res.data.data;
        
            setpayroll_tracks(responseData)
          } else {
            cogoToast.error(res.data.message, {});
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };
  const savePayroll =  (e) => {
    setIsLoading(true)
    e?.preventDefault();
let _employees=[];
 
gridRef?.current?.api?.getSelectedRows().forEach(element => {
  _employees.push(element.id)
});


   let data= {
    "track_id": selected_track_id,
    "status": saveStatus,
    "employees":  _employees
}
  
   
  console.clear();
  console.log(data);
  
  
  genericPost(ENDPOINTS.PROCESS_PAYROLL, data)
  .then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
            
              cogoToast.success(response.data.message, {
                  hideAfter: 5,
              });
               
             listPayrollDetails();
             listTracks();
             setshowModal(false);

          } else {
              cogoToast.error(response.data.message, {
                  hideAfter: 5,
              });
          }
      }
  })
  .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
      });
  });
   
   
  }

  const exportToExcel = () => {
    if (!rowData || rowData.length === 0) {
      cogoToast.error("No data available to export", {
        hideAfter: 5,
      });
      return;
    }

    try {
      // Prepare data for Excel export
      const excelData = rowData.map((row, index) => {
        return {
          '#': index + 1,
          'Staff ID': row.staff_code || '',
          'Staff Name': row.staff_name || '',
          'Designation': row.role_name || '',
          'Department': row.department || '',
          'Sector': row.sector || '',
          'Office': row.office_name || '',
          'Track Name': row.track_name || '',
          'Period': row.month_name && row.year ? `${row.month_name} ${row.year}` : '',
          'Hours Worked': parseFloat(row.hrs_worked) || 0,
          'Leave Hours': parseFloat(row.total_leave_hrs) || 0,
          'Basic Salary': parseFloat(row.basic_salary) || 0,
          'Total Allowances': parseFloat(row.total_allowances) || 0,
          'Total Benefits': parseFloat(row.total_benefits) || 0,
          'Gross Earnings': parseFloat(row.gross_earnings) || 0,
          'Total Earnings': parseFloat(row.total_earnings) || 0,
          'Adjusted Earnings': parseFloat(row.total_adjusted_earning) || 0,
          'Taxes': parseFloat(row.total_taxes) || 0,
          'Adjusted Deductions': parseFloat(row.total_adjusted_deduction) || 0,
          'Other Deductions': parseFloat(row.total_other_deductions) || 0,
          'Net Pay': parseFloat(row.net_pay) || 0,
          'Contract Start Date': row.contract_start_date || '',
          'Contract End Date': row.contract_end_date || '',
          'Email': row.email || '',
          'Status': row.payroll_status === 10003 ? 'Draft' : row.payroll_status === 10001 ? 'Final' : '',
        };
      });

      // Create workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);

      // Set column widths
      ws['!cols'] = [
        { wch: 5 },   // #
        { wch: 12 },  // Staff ID
        { wch: 25 },  // Staff Name
        { wch: 20 },  // Designation
        { wch: 25 },  // Department
        { wch: 15 },  // Sector
        { wch: 20 },  // Office
        { wch: 25 },  // Track Name
        { wch: 15 },  // Period
        { wch: 12 },  // Hours Worked
        { wch: 12 },  // Leave Hours
        { wch: 15 },  // Basic Salary
        { wch: 18 },  // Total Allowances
        { wch: 15 },  // Total Benefits
        { wch: 15 },  // Gross Earnings
        { wch: 15 },  // Total Earnings
        { wch: 18 },  // Adjusted Earnings
        { wch: 12 },  // Taxes
        { wch: 20 },  // Adjusted Deductions
        { wch: 18 },  // Other Deductions
        { wch: 15 },  // Net Pay
        { wch: 18 },  // Contract Start Date
        { wch: 18 },  // Contract End Date
        { wch: 30 },  // Email
        { wch: 12 },  // Status
      ];

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Payroll Data');

      // Generate filename with current date
      const trackName = payroll_tracks.find(t => t.id === selected_track_id)?.name || 'Payroll';
      const statusName = status === '10003' ? 'Draft' : 'Completed';
      const filename = `${trackName}_${statusName}_${new Date().toISOString().split('T')[0]}`;

      // Generate Excel file and trigger download
      XLSX.writeFile(wb, `${filename}.xlsx`);

      cogoToast.success("Excel file exported successfully", {
        hideAfter: 5,
      });
    } catch (error) {
      console.error('Excel export error:', error);
      cogoToast.error("Failed to export Excel file: " + error.message, {
        hideAfter: 5,
      });
    }
  };

  const undoPayroll = () => {
    const selectedStaff = gridRef?.current?.api?.getSelectedRows() || [];
    
    if (selectedStaff.length === 0) {
      cogoToast.error("Please select at least one staff member", {});
      return;
    }

    if (!selected_track_id) {
      cogoToast.error("Please select a payroll track", {});
      return;
    }

    // Build staff_ids array
    const staffIds = selectedStaff.map(staff => staff.id);

    const data = {
      track_id: selected_track_id,
      staff_ids: staffIds
    };

    setIsLoading(true);
    genericPost(ENDPOINTS.UNDO_PAYROLL, data)
      .then((response) => {
        setIsLoading(false);
        setShowUndoModal(false);
        if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
            cogoToast.success(response.data.message || "Payroll undone successfully", {
              hideAfter: 5,
            });
            listPayrollDetails();
            listTracks();
          } else {
            cogoToast.error(response.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please try again. " + err, {
          hideAfter: 5,
        });
      });
  };

  return (
    <div>
       <Loader loading={isLoading}/>
      <div className="row">
        <div className="col-md-5">
          <h1> Draft Payroll </h1>
        </div> 
        <hr/>
        <div className="col-md-10">
    
       <div className="row">

{/* <CardBox title={"TOTAL EMPLOYEES"} value={payroll_info?.total_employees} icon={"fa fa-group"}  ></CardBox>
<CardBox title={" Total Payroll "} value={payroll_info?.total_payroll} icon={"fa fa-dollar"}  ></CardBox>
<CardBox title={" Cash Required "} value={payroll_info?.cash_required} icon={"fa fa-dollar"}  ></CardBox>
<CardBox title={"   Total Tax "} value={payroll_info?.total_tax} icon={"fa fa-dollar"}  ></CardBox> */}


<div className="row">
  <div className="col-md-4">
    Select Track
    <select onChange={(e)=>setSelected_track_id(e.target.value)} className="form-control">

   <option value=""> Select Track </option>

{payroll_tracks?.map((p)=>{
  return  <option value={p.id}> {p.name}</option>
  
})}
 </select>
  </div>
  <div className="col-md-4">
    Select Payroll status
  <select onChange={(e)=>{setstatus(e.target.value);
setTimeout(() => {
 
}, 1000);

  }} className="form-control">
  {/* <option value={""}>Select Status</option> */}
    
    <option value={10003}>DRAFT</option>
    {/* <option value={10001}>Completed</option> */}

    </select>
  </div>
  <div className="col-md-1"> <br/>
    <button className="btn-sm btn-primary" onClick={()=>listPayrollDetails()}>View</button>
  </div>
  <div className="col-md-2"> <br/>
    <button 
      className="btn-sm btn-success" 
      onClick={exportToExcel}
      disabled={!rowData || rowData.length === 0}
      style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
    >
      <FaFileExport /> Export to Excel
    </button>
  </div>
</div>





 </div>
        </div>
      </div>
     

      {/* Summary Cards */}
      <div className="row mb-2 mt-2">
      <div className="col-md-2">
          <CardBox 
            title="Employees" 
            value={`${rowData?.length || 0}`} 
            icon="fa fa-chart-line" 
          />
        </div>
        <div className="col-md-2">
          <CardBox 
            title="Total Earnings" 
            value={`$ ${rowData?.reduce((sum, row) => sum + (parseFloat(row.total_earnings) || 0), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} 
            icon="fa fa-chart-line" 
          />
        </div>
        <div className="col-md-2">
          <CardBox 
            title="Total Taxes" 
            value={`$ ${rowData?.reduce((sum, row) => sum + (parseFloat(row.total_taxes) || 0), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} 
            icon="fa fa-file-invoice-dollar" 
          />
        </div>
       
        <div className="col-md-2">
          <CardBox 
            title="Total Deductions" 
            value={`$ ${rowData?.reduce((sum, row) => {
              const taxes = parseFloat(row.total_taxes) || 0;
              const adjDeductions = parseFloat(row.total_adjusted_deduction) || 0;
              const otherDeductions = parseFloat(row.total_other_deductions) || 0;
              return sum + taxes + adjDeductions + otherDeductions;
            }, 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} 
            icon="fa fa-calculator" 
          />
        </div>
        <div className="col-md-3">
          <CardBox 
            title="Total Net Pay" 
            value={`$ ${rowData?.reduce((sum, row) => sum + (parseFloat(row.net_pay) || 0), 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`} 
            icon="fa fa-dollar-sign" 
          />
        </div>
      </div>
      

     
      <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          rowSelection={"multiple"}
          groupSelectsChildren={true}
          onCellClicked={(e) => {
            console.log(e.data);
          }}
          suppressRowClickSelection={true}
          onRowSelected={(e) => {
            if (e.data?.staff_id != null) {
              //calculate_tests();
            } else {
            
              return;
            }
          }}
          onSelectionChanged={(e) => {
            if ( e.data?.staff != null) {
              //calculate_tests();
            }
          }}

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
          //  params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              pinned: 'left',
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },
            {
              headerCheckboxSelection: true,
              checkboxSelection: true,
              headerName: "Staff ID",
              field: "staff_code",
              sortable: true,
              filter: true,
              maxWidth: 120,
              pinned: 'left',
            },
            {
              headerName: "Staff Name",
              field: "staff_name",
              sortable: true,
              filter: true,
              minWidth: 180,
            },
            {
              headerName: "Designation",
              field: "role_name",
              sortable: true,
              filter: true,
              minWidth: 150,
            },
            {
              headerName: "Department",
              field: "department",
              sortable: true,
              filter: true,
              minWidth: 180,
            },
            {
              headerName: "Sector",
              field: "sector",
              sortable: true,
              filter: true,
              maxWidth: 120,
            },
            {
              headerName: "Office",
              field: "office_name",
              sortable: true,
              filter: true,
              minWidth: 120,
            },
            {
              headerName: "Track Name",
              field: "track_name",
              sortable: true,
              filter: true,
              minWidth: 180,
            },
            {
              headerName: "Period",
              field: "month_name",
              sortable: true,
              filter: true,
              valueFormatter: (params) => {
                if (params.data?.month_name && params.data?.year) {
                  return `${params.data.month_name} ${params.data.year}`;
                }
                return params.value || '';
              },
              maxWidth: 150,
            },
            {
              headerName: "Hours Worked",
              field: "hrs_worked",
              sortable: true,
              filter: true,
              maxWidth: 120,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toFixed(2) : '0.00';
              },
            },
            {
              headerName: "Leave Hours",
              field: "total_leave_hrs",
              sortable: true,
              filter: true,
              maxWidth: 120,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toFixed(2) : '0.00';
              },
            },
            {
              headerName: "Basic Salary",
              field: "basic_salary",
              sortable: true,
              filter: true,
              maxWidth: 130,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right' },
            },
            {
              headerName: "Total Allowances",
              field: "total_allowances",
              sortable: true,
              filter: true,
              maxWidth: 150,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', color: '#28a745' },
            },
            {
              headerName: "Total Benefits",
              field: "total_benefits",
              sortable: true,
              filter: true,
              maxWidth: 140,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right' },
            },
            {
              headerName: "Gross Earnings",
              field: "gross_earnings",
              sortable: true,
              filter: true,
              maxWidth: 140,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', fontWeight: 'bold' },
            },
            {
              headerName: "Total Earnings",
              field: "total_earnings",
              sortable: true,
              filter: true,
              maxWidth: 140,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', fontWeight: 'bold' },
            },
            {
              headerName: "Adj. Earnings",
              field: "total_adjusted_earning",
              sortable: true,
              filter: true,
              maxWidth: 130,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', color: '#28a745' },
            },
            {
              headerName: "Taxes",
              field: "total_taxes",
              sortable: true,
              filter: true,
              maxWidth: 120,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', color: '#dc3545' },
            },
            {
              headerName: "Adj. Deductions",
              field: "total_adjusted_deduction",
              sortable: true,
              filter: true,
              maxWidth: 150,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', color: '#dc3545' },
            },
            {
              headerName: "Other Deductions",
              field: "total_other_deductions",
              sortable: true,
              filter: true,
              maxWidth: 150,
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', color: '#dc3545' },
            },
            {
              headerName: "Net Pay",
              field: "net_pay",
              sortable: true,
              filter: true,
              maxWidth: 130,
              pinned: 'right',
              valueFormatter: (params) => {
                return params.value ? parseFloat(params.value).toLocaleString('en-US', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }) : '0.00';
              },
              cellStyle: { textAlign: 'right', fontWeight: 'bold', color: '#28a745', backgroundColor: '#f0f9f0' },
            },
            {
              headerName: "Contract Start",
              field: "contract_start_date",
              sortable: true,
              filter: true,
              maxWidth: 130,
              valueFormatter: (params) => {
                if (params.value) {
                  return new Date(params.value).toLocaleDateString();
                }
                return '';
              },
            },
            {
              headerName: "Contract End",
              field: "contract_end_date",
              sortable: true,
              filter: true,
              maxWidth: 130,
              valueFormatter: (params) => {
                if (params.value) {
                  return new Date(params.value).toLocaleDateString();
                }
                return '';
              },
            },
            {
              headerName: "Email",
              field: "email",
              sortable: true,
              filter: true,
              minWidth: 200,
            },
            {
              headerName: "Status",
              field: "payroll_status",
              sortable: true,
              filter: true,
              maxWidth: 100,
              valueFormatter: (params) => {
                if (params.value === 10003) return 'Draft';
                if (params.value === 10001) return 'Final';
                return params.value || '';
              },
              cellStyle: (params) => {
                if (params.value === 10003) return { color: '#ffc107', fontWeight: 'bold' };
                if (params.value === 10001) return { color: '#28a745', fontWeight: 'bold' };
                return {};
              },
            },
          ]}
        ></AgGridReact>
      </div>{" "}

<hr/>



 

      <Modal
        isOpen={showModal}
        onHide={() => setshowModal(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             SAVE PAYROLL 
               
               
          </div>
           
          
         </ModalHeader>
        <ModalBody>
      

        <form onSubmit={savePayroll}>
          <h3> SELECTED STAFF  : {gridRef?.current?.api?.getSelectedRows().length} out of {rowData.length}</h3>
<div className="row">

  
 
  
 

    <div className="col-md-6">
  
<br/>
Save as
<select name="status"
            className="form-control"
            onChange={(e) => {setSavestatus(e.target.value)}
               
             
            }
            required={true}
          >
            
            <option value={10001}>Final </option>
            {/* <option value={10002}>Deactivated </option> */}
            


            </select>
</div>
 
<div className="col-md-6">  
 
  
<br/>
<br/>
  {!isLoading ?
    <input  type="submit" disabled={gridRef?.current?.api?.getSelectedRows().length==0 ||   saveStatus==null} className="btn btn-primary" value="Save Payroll" ></input> : <button className="btn btn-primary" disabled={true}><Spinner /> &nbsp; Processing..</button>  }

    </div>
    </div>
     
    </form>
        </ModalBody>
      
      </Modal>

      <Fab
     
 
  icon={ <i className="fa fa-save"></i>  }
  event={null}
  alwaysShowTitle={true}
  onClick={(e)=>{
    setshowModal(true);
 
  }}
  text= {"Save Payroll >"}
  style={{ bottom: '80px', right: '20px' }}
>
   
</Fab>

      <Fab
        icon={<i className="fa fa-undo"></i>}
        event={null}
        alwaysShowTitle={true}
        onClick={(e) => {
          const selectedStaff = gridRef?.current?.api?.getSelectedRows() || [];
          if (selectedStaff.length === 0) {
            cogoToast.error("Please select at least one staff member", {});
            return;
          }
          if (!selected_track_id) {
            cogoToast.error("Please select a payroll track", {});
            return;
          }
          setShowUndoModal(true);
        }}
        text={"Undo Payroll >"}
        style={{ bottom: '20px', right: '20px', backgroundColor: '#dc3545' }}
      >
      </Fab>

      {/* Undo Payroll Confirmation Modal */}
      <Modal
        isOpen={showUndoModal}
        toggle={() => setShowUndoModal(false)}
        backdrop={true}
        size="lg"
      >
        <ModalHeader toggle={() => setShowUndoModal(false)}>
          <div className="row">
            <span style={{ color: '#dc3545' }}>⚠️ Undo Payroll Confirmation</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <div style={{ padding: '10px' }}>
            <h4 style={{ color: '#dc3545', marginBottom: '20px' }}>
              Warning: This will set the payroll status back to DRAFT
            </h4>
            <p style={{ fontSize: '16px', marginBottom: '20px' }}>
              Are you sure you want to undo payroll for the selected staff members?
            </p>
            
            <div style={{
              backgroundColor: '#f8f9fa',
              padding: '15px',
              borderRadius: '8px',
              border: '1px solid #dee2e6',
              marginBottom: '20px'
            }}>
              <h5 style={{ marginBottom: '10px', color: '#495057' }}>
                Total Staff Selected: <strong style={{ color: '#dc3545' }}>
                  {gridRef?.current?.api?.getSelectedRows().length || 0}
                </strong>
              </h5>
              <p style={{ margin: 0, color: '#6c757d', fontSize: '14px' }}>
                Payroll will be reverted to DRAFT status for all selected staff members.
              </p>
            </div>

            <h6 style={{ 
              marginBottom: '15px', 
              color: '#495057',
              fontSize: '15px',
              fontWeight: '600'
            }}>
              Staff Details:
            </h6>

            <div style={{
              maxHeight: '400px',
              overflowY: 'auto',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              padding: '10px'
            }}>
              <table className="table table-bordered table-hover" style={{ marginBottom: 0 }}>
                <thead style={{ backgroundColor: '#f8f9fa', position: 'sticky', top: 0 }}>
                  <tr>
                    <th style={{ fontSize: '13px', padding: '8px' }}>Staff Name</th>
                    <th style={{ fontSize: '13px', padding: '8px', textAlign: 'right' }}>Basic Salary</th>
                    <th style={{ fontSize: '13px', padding: '8px', textAlign: 'right' }}>Allowances</th>
                    <th style={{ fontSize: '13px', padding: '8px', textAlign: 'right' }}>Taxes</th>
                    <th style={{ fontSize: '13px', padding: '8px', textAlign: 'right' }}>Gratuity</th>
                    <th style={{ fontSize: '13px', padding: '8px', textAlign: 'right', fontWeight: 'bold', color: '#28a745' }}>Net Pay</th>
                  </tr>
                </thead>
                <tbody>
                  {gridRef?.current?.api?.getSelectedRows().map((staff, index) => (
                    <tr key={staff.id || index}>
                      <td style={{ padding: '8px', fontSize: '13px' }}>
                        <strong>{staff.staff_name || 'N/A'}</strong>
                        {staff.role_name && (
                          <div style={{ fontSize: '11px', color: '#6c757d', marginTop: '2px' }}>
                            {staff.role_name}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right' }}>
                        {staff.basic_salary ? parseFloat(staff.basic_salary).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) : '0.00'}
                      </td>
                      <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right', color: '#28a745' }}>
                        {staff.total_allowances ? parseFloat(staff.total_allowances).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) : '0.00'}
                      </td>
                      <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right', color: '#dc3545' }}>
                        {staff.total_taxes ? parseFloat(staff.total_taxes).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) : '0.00'}
                      </td>
                      <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right' }}>
                        {staff.gratuity ? parseFloat(staff.gratuity).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) : '0.00'}
                      </td>
                      <td style={{ padding: '8px', fontSize: '14px', textAlign: 'right', fontWeight: 'bold', color: '#28a745' }}>
                        {staff.net_pay ? parseFloat(staff.net_pay).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) : '0.00'}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
                  <tr>
                    <td style={{ padding: '8px', fontSize: '13px' }}>Total</td>
                    <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right' }}>
                      {gridRef?.current?.api?.getSelectedRows().reduce((sum, staff) => 
                        sum + (parseFloat(staff.basic_salary) || 0), 0
                      ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right', color: '#28a745' }}>
                      {gridRef?.current?.api?.getSelectedRows().reduce((sum, staff) => 
                        sum + (parseFloat(staff.total_allowances) || 0), 0
                      ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right', color: '#dc3545' }}>
                      {gridRef?.current?.api?.getSelectedRows().reduce((sum, staff) => 
                        sum + (parseFloat(staff.total_taxes) || 0), 0
                      ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: '8px', fontSize: '13px', textAlign: 'right' }}>
                      {gridRef?.current?.api?.getSelectedRows().reduce((sum, staff) => 
                        sum + (parseFloat(staff.gratuity) || 0), 0
                      ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                    <td style={{ padding: '8px', fontSize: '14px', textAlign: 'right', fontWeight: 'bold', color: '#28a745' }}>
                      {gridRef?.current?.api?.getSelectedRows().reduce((sum, staff) => 
                        sum + (parseFloat(staff.net_pay) || 0), 0
                      ).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button 
            color="secondary" 
            onClick={() => setShowUndoModal(false)}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button 
            color="danger" 
            onClick={undoPayroll}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner size="sm" /> &nbsp; Undoing...
              </>
            ) : (
              'Undo Payroll'
            )}
          </Button>
        </ModalFooter>
      </Modal>
      
    </div>



  );
};

export default PayrollSelection;
